module.exports = __webpack_public_path__ + "static/media/Dashboard_03-Places.1717db0f.jpg";